import { axiosSEC } from "../http-common";

const getParameters = (idEstacionamento: string) => {
    return axiosSEC.get(`Parametros/${idEstacionamento}`);
}

const ParametersService = {
    getParameters
};

export default ParametersService;
